import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=ab13bf2e&"
import script from "XC/components/chat/chat.component.js?vue&type=script&lang=js&"
export * from "XC/components/chat/chat.component.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports